import Tvc from './components/Tvc';

export default Tvc;
